import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import { RelativityFieldsResponse } from '../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

interface UseGetRelativityWorkspaceFieldsOptions {
  workspaceId: number | null;
  enabled?: boolean;
  refetchOnWindowFocus?: boolean;
}

const useGetRelativityWorkspaceFields = (options: UseGetRelativityWorkspaceFieldsOptions) => {
  const { workspaceId, enabled = true, refetchOnWindowFocus = false } = options;
  const { fetchConfigGET } = useGetFetchConfig();

  const getWorkspaceFields = async (): Promise<RelativityFieldsResponse> => {
    if (!workspaceId) {
      throw new Error('Workspace ID is required');
    }

    const url = `${APIBaseChronos}/api/relativity-mappings/workspaces/${workspaceId}/fields`;
    const response = await fetch(url, fetchConfigGET);

    if (!response.ok) {
      throw new Error(`Failed to fetch workspace fields: ${response.status} ${response.statusText}`);
    }

    return response.json();
  };

  return useQuery([QueryEntity.RelativityWorkspaceFields, { workspaceId }], getWorkspaceFields, {
    enabled: enabled && workspaceId !== null,
    refetchOnWindowFocus,
    retry: (failureCount, error) => {
      if (error instanceof Error && (error.message.includes('401') || error.message.includes('403'))) {
        return false;
      }
      return failureCount < 2;
    },
  });
};

export default useGetRelativityWorkspaceFields;
